/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.feed.describeFeedGenerator'

export { $nsid }

/** Get information about a feed generator, including policies and offered feed URIs. Does not require auth; implemented by Feed Generator services (not App View). */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    did: l.string({ format: 'did' }),
    feeds: l.array(l.ref<Feed>((() => feed) as any)),
    links: l.optional(l.ref<Links>((() => links) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Feed = {
  $type?: 'app.bsky.feed.describeFeedGenerator#feed'
  uri: l.AtUriString
}

export type { Feed }

const feed = l.typedObject<Feed>(
  $nsid,
  'feed',
  l.object({ uri: l.string({ format: 'at-uri' }) }),
)

export { feed }

type Links = {
  $type?: 'app.bsky.feed.describeFeedGenerator#links'
  privacyPolicy?: string
  termsOfService?: string
}

export type { Links }

const links = l.typedObject<Links>(
  $nsid,
  'links',
  l.object({
    privacyPolicy: l.optional(l.string()),
    termsOfService: l.optional(l.string()),
  }),
)

export { links }
